<template>
  <div class="container">
    <h4 class="alert alert-danger">
      You are not authorized to edit or add data to TerraTrac. Please contact your IT administrator
      if you believe you should have access to this functionality.
    </h4>
  </div>
</template>

<script>
export default {
  name: 'ViewOnly',
};
</script>
